import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { from, Observable, of, ReplaySubject, throwError } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { resolve } from 'src/app/utils/resolve';
import { storage } from 'src/app/utils/storage';
import { Resposta } from 'src/app/interfaces/resposta';

export interface Autorizacao {
  access_token: string;
  cpf: string;
}

@Injectable({
  providedIn: 'root'
})
export class AutorizacaoService {
  public autorizacao$: ReplaySubject<Autorizacao>;
  public logout$: ReplaySubject<boolean>;

  constructor(
    private http: HttpClient
  ) {
    this.autorizacao$ = new ReplaySubject<Autorizacao>(1);
    this.logout$ = new ReplaySubject(1);
    this.autorizacao$
      .pipe(
        mergeMap(autorizacao => storage.set('autorizacao', autorizacao))
      )
      .subscribe();
    from(storage.get('autorizacao'))
      .pipe(mergeMap(autorizacao => {
        return this.usar(autorizacao);
      }))
      .subscribe();
  }

  login(code: string, redirectUri: string): Observable<Autorizacao> {
    const url = resolve('egresso://seguranca/oauth', {code, redirectUri});
    const headers = new HttpHeaders().append('x-skip-autorizacao', '1');
    return this
      .http
        .get<Resposta<Autorizacao>>(url, {headers})
      .pipe(
        map((response) => response.data),
        catchError(err => {
          if (err.status === 401) {
            const mensagem = 'Não foi possível autenticar-se usando as credenciais fornecidas.';
            return throwError(mensagem);
          } else {
            return throwError('Não foi possível autenticar-se. Verifique sua conexão e tente novamente mais tarde.');
          }
        })
      );
  }

  async autorizacao(): Promise<Autorizacao> {
    return storage.get('autorizacao');
  }

  usar(autorizacao: Autorizacao): Observable<Autorizacao> {
    console.log('autorizacao', autorizacao);
    this.autorizacao$.next(autorizacao);
    return of(autorizacao);
  }

  delete() {
    return storage.remove('autorizacao');
  }

  refresh(username: string, password: string) {
    return this.login(username, password)
      .pipe(
        mergeMap((auth) => this.usar(auth))
      );
  }
}
